import React, { useContext } from 'react'
import { TypeItemFeatureHighlight } from '../../../lib/types'
import { TypeAlignment } from '../../../lib/types/alignment'
import { Background } from '../../../lib/types/background'
import { FeatureHighlightProvider } from '../../../contexts/feature-highlight-context'
import { AlignmentContext, DefaultAlignment } from '../../../contexts/alignment-context'
import { SingleColumnLayout } from '../../layout/single-column'
import { FeatureHighlight } from '../../item/feature-highlight'
import { FixedSpacer } from '@grammarly/badger-ui'
import { SectionThemeContext } from '../../../contexts/section-theme-context'
import { useBackgroundStyle } from '../../page-section/theme'
import cn from 'classnames'

interface TabSectionProps {
  className?: string
  background?: Background
  heading?: TypeItemFeatureHighlight
  alignment?: TypeAlignment
  children: React.ReactNode
}

export const TabSection: React.FC<TabSectionProps> = ({ className, alignment, heading, background, children }) => {
  const theme = useContext(SectionThemeContext)
  const backgroundStyle = useBackgroundStyle(theme, background?.color)

  return (
    <div className={cn(...backgroundStyle, className)}>
      {heading && (
        <FeatureHighlightProvider value={{ titleStyle: 'T1' }}>
          <AlignmentContext.Provider value={alignment?.fields ?? DefaultAlignment}>
            <SingleColumnLayout>
              <FeatureHighlight structure={heading} titleTag="h2" />
              <FixedSpacer multiplier={7} />
            </SingleColumnLayout>
          </AlignmentContext.Provider>
        </FeatureHighlightProvider>
      )}
      {children}
    </div>
  )
}
